import React from 'react';
import PropTypes from 'prop-types';

const ICON_SIZE = 16;

function ChevronRightIconSmall({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={ICON_SIZE}
      height={ICON_SIZE}
      viewBox="0 0 16 16"
      className={className}
    >
      <path d="M10.354 8.354l-4 4a.5.5 0 0 1-.708-.708L9.293 8 5.646 4.354a.5.5 0 1 1 .708-.708l4 4a.5.5 0 0 1 0 .708z" />
    </svg>
  );
}

ChevronRightIconSmall.propTypes = {
  className: PropTypes.string,
};

ChevronRightIconSmall.ICON_SIZE = ICON_SIZE;

export default ChevronRightIconSmall;
